/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppReleaseControllerList200ResponseDataSummaryInner { 
    platform?: AppReleaseControllerList200ResponseDataSummaryInner.PlatformEnum;
    latestVersion?: string | null;
    minSupportedVersion?: string | null;
    pendingVersions?: Array<string>;
}
export namespace AppReleaseControllerList200ResponseDataSummaryInner {
    export type PlatformEnum = 'web' | 'ios' | 'android';
    export const PlatformEnum = {
        Web: 'web' as PlatformEnum,
        Ios: 'ios' as PlatformEnum,
        Android: 'android' as PlatformEnum
    };
}


